import AvatarGroup from "common/Avatars/AvatarGroup";
import ExchangeAvatar from "common/Avatars/ExchangeAvatar";
import { CSSProperties } from "react";
import { ICON_TYPES } from "@shared/common/constants";
import { useSymbolsCoins } from "@shared/features/bots/BotForm/common/hooks";
import { uniq } from "lodash";

interface CoinsIconsGroupProps {
  coins?: string[];
  size?: number;
  style?: CSSProperties;
  maxCount?: number;
  symbols?: string[];
  exchange?: string;
  hideTooltips?: boolean;
  isUnique?: boolean;
}

const CoinsIconsGroup = ({
  coins: propsCoins,
  size,
  style,
  maxCount = 3,
  symbols,
  exchange,
  hideTooltips,
  isUnique = true,
}: CoinsIconsGroupProps) => {
  const symbolCoins = useSymbolsCoins(symbols || [], exchange);
  const coins = propsCoins ?? symbolCoins ?? [];
  const filteredCoins = isUnique ? uniq(coins) : coins;
  let avatarsData: { key: string; title: string; text: string }[];

  if (filteredCoins) {
    avatarsData = filteredCoins.map((coin, index) => ({
      key: `${coin}_${index}`,
      title: coin,
      text: coin,
      iconType: ICON_TYPES.COIN,
    }));
  } else {
    return null;
  }

  return (
    <AvatarGroup
      avatarsData={avatarsData}
      maxCount={avatarsData.length === maxCount ? maxCount : maxCount - 1}
      AvatarComponent={ExchangeAvatar}
      size={size}
      style={style}
      hideTooltips={hideTooltips}
      totalCount={coins.length}
    />
  );
};

export default CoinsIconsGroup;
